import { flexRender } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/table";
import { useTable } from "~/hooks/use-table";
import { SearchTerm } from "~/integrations/firebase/collections/search-terms";
import { getColumns } from "./columns";
import { SearchTermsAmazonTableBody } from "./search-terms-amazon-table-body";

export const SearchTermsAmazonTable = ({
  searchTerms,
  isLoading,
}: {
  searchTerms: SearchTerm[];
  isLoading: boolean;
}) => {
  const { t } = useTranslation(["searchTerms"]);

  const columns = useMemo(() => getColumns(t), [t]);

  const { table } = useTable({
    columns,
    data: searchTerms,
    totalRecords: searchTerms?.length || 0,
    getRowId: (row) => row.id,
  });

  return (
    <Table>
      <TableHeader>
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <TableHead
                key={header.id}
                colSpan={header.colSpan}
                style={{ width: header.getSize() || undefined }}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
              </TableHead>
            ))}
            <TableHead className="w-10" />
          </TableRow>
        ))}
      </TableHeader>

      <TableBody>
        <SearchTermsAmazonTableBody table={table} isLoading={isLoading} />
      </TableBody>
    </Table>
  );
};
